// extracted by mini-css-extract-plugin
export default {"Question":"styles_Question__nWF-d","question":"styles_question__9+KzO","answer":"styles_answer__CZECj"};